module.exports = __webpack_public_path__ + "images/CC_Question Text + Image.svg";